module.exports = __webpack_public_path__ + "static/media/image-not-found.3fd23692.jpg";